import c from "./consts";

export default {
  [c.IS_LOADING](state, value) {
    state[c.IS_LOADING] = value;
  },

  [c.CURRENT_USER](state, value) {
    state[c.CURRENT_USER] = value;
  },

  [c.AUTH_INITIALIZED](state, value) {
    state[c.AUTH_INITIALIZED] = value;
  }
}